module.exports = __webpack_public_path__ + "img/2-1.1649faf4.png";